// 「チェックした商品」（#check_swiper）を描画する。theme.liquid の inline script が localStorage
// 'recentlyViewedProduct' に保存した閲覧履歴を読み、Swiper のスライドとして描画する（保存は行わない）。
// 検索パネルの閲覧履歴（quicklook-search.js の #prtcRecentlyViewedProducts）とはデータ源を共有するが、
// UI・描画タイミングが異なる別レイヤーとして自己完結させている。

const CHECKED_PRODUCTS_KEY = 'recentlyViewedProduct';
const CHECKED_PRODUCTS_MAX = 8;

/** localStorage から閲覧履歴配列を読む。未保存/壊れていれば null。 */
function checkedProductsLoad() {
  try {
    const data = JSON.parse(localStorage.getItem(CHECKED_PRODUCTS_KEY));
    return Array.isArray(data) ? data : null;
  } catch (e) {
    return null;
  }
}

/**
 * 閲覧履歴 1 件を「チェックした商品」カード（swiper-slide＋商品名）に組み立てる。
 * XSS セーフ: createElement / textContent のみを使う。
 * 画像は英語表示なら productImgEn を優先し、無ければ productImg（日本語）へフォールバックする。
 */
function checkedProductsBuildItem(item, placeholder, isEn) {
  const wrap = document.createElement('div');
  wrap.className = 'Item swiper-slide';
  const link = document.createElement('a');
  link.className = 'Item_inner';
  link.href = item.productUrl || '#';
  const img = document.createElement('img');
  img.src = (isEn && item.productImgEn) || item.productImg || placeholder;
  // 下に商品名テキストがあるため、冗長な読み上げを避けて alt は空にする。
  img.alt = '';
  link.appendChild(img);
  const body = document.createElement('h3');
  body.className = 'Item_body';
  const p = document.createElement('p');
  p.textContent = item.productTitle || '';
  body.appendChild(p);
  link.appendChild(body);
  wrap.appendChild(link);
  return wrap;
}

/** 閲覧履歴（新しい順・最大 CHECKED_PRODUCTS_MAX 件）のカード群を DocumentFragment で返す。 */
function checkedProductsBuildFragment(data, placeholder, isEn) {
  const frag = document.createDocumentFragment();
  data
    .slice(-CHECKED_PRODUCTS_MAX)
    .reverse()
    .forEach((item) => frag.appendChild(checkedProductsBuildItem(item, placeholder, isEn)));
  return frag;
}

/**
 * 「チェックした商品」(#check_swiper) を描画する。Swiper 初期化はスライドが揃ってから行うため、
 * recently-viewed-products.liquid が初期化の直前に同期呼び出しする。
 * 履歴が無ければ旧「チェックした商品」系の残骸要素を撤去する。
 */
window.renderCheckedProducts = function () {
  const container = document.getElementById('check_swiper');
  if (!container) return;
  const data = checkedProductsLoad();
  if (!data) {
    document
      .querySelectorAll('.prtc_checked, .prtc_recently_viewed_products_area, .Checked')
      .forEach((el) => el.remove());
    return;
  }
  const isEn = (document.documentElement.lang || '').toLowerCase().slice(0, 2) === 'en';
  container.replaceChildren(checkedProductsBuildFragment(data, container.dataset.noImage || '', isEn));
};
